export const FL = {
  navContact: "nav-contact-btn",
  heroCta: "hero-cta-btn",
  heroCtaMessage: "hero-cta-message-btn",
  followBtn: "profile-follow-btn",
  messageBtn: "profile-message-btn",
  contactBtn: "profile-contact-btn",
  highlight: (id) => `highlight-${id}`,
  highlightRow: "highlights-row",
  storyModal: "story-modal",
  storyClose: "story-close-btn",
  storyNext: "story-next-tap",
  storyPrev: "story-prev-tap",
  post: (id) => `post-${id}`,
  postGrid: "post-grid",
  postModal: "post-modal",
  postModalClose: "post-modal-close",
  postNext: "post-next-btn",
  postPrev: "post-prev-btn",
  servicesSection: "services-section",
  contactSection: "contact-section",
  contactForm: "contact-form",
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactPhone: "contact-phone",
  contactEventType: "contact-event-type",
  contactEventDate: "contact-event-date",
  contactMessage: "contact-message",
  contactSubmit: "contact-submit-btn",
  footer: "footer",
  waLink: "footer-whatsapp",
  igLink: "footer-instagram",
};
